import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { formsV2 as Forms } from '@breezeway/brzw-components';

export class SearchInputWithState extends PureComponent {
  constructor(props) {
    super(props);

    const { defaultValue } = props;

    this.state = {
      searchInputValue: defaultValue,
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.setState(
      {
        searchInputValue: value,
      },
      () => {
        _.invoke(this.props, 'onChange', value);
      },
    );
  }

  render() {
    const { searchInputValue } = this.state;
    return <Forms.Input {...this.props} onChange={this.onChange} value={searchInputValue} />;
  }
}

SearchInputWithState.propTypes = {
  className: PropTypes.string,
  iconName: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  placeholderText: PropTypes.string,
  defaultValue: PropTypes.string,
};

SearchInputWithState.defaultProps = {
  iconName: 'search',
  id: 'search_input',
  placeholderText: 'Search',
  defaultValue: '',
};

export default SearchInputWithState;
